function LandingPage() {
  return (
    <section className="landing-page">
      Hey guys!
      <p>
        Welcome to the BOSS Marketplace! It's Miss Alexis, and we're currently
        cleaning out our costume room! We're selling most of our costumes at
        discounted rates just in time for Halloween!
      </p>
      <h4>How to browse this site</h4>
      <p>
        Please use the navigation at the top to browse through our products. If
        you hover or press on a photo, you'll see what products are being sold
        on that photo. Click on the title to send me a message about the
        product!
      </p>
      <h4>Delivery</h4>
      <p>
        I will mail certain items as long as they're not fragile or too big!
      </p>
      <p>
        If I personally know you, visiting me in person is best as some items
        are not listed here! For questions, DM me on instagram:{" "}
        <a href="https://www.instagram.com/lovemissalexis/">@lovemissalexis</a>{" "}
        or email me at{" "}
        <a href="mailto:someone@yoursite.com">alexis.borja@gmail.com</a>.
      </p>
      <p> Thank you, and happy shopping!</p>
    </section>
  );
}

export default LandingPage;
